import { Spinner } from "react-bootstrap"
import '../styles/SpinnerLoader.css'
export default function SpinnerLoader() {
    return (
        <div className="Spinner">
            <Spinner animation="border" role="status"/>
        </div>
    )

}